import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconArrowBack1 } from "../../../../../icons/IconArrowBack1";
import { IconChevronDown1 } from "../../../../../icons/IconChevronDown1";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoOnboardingCardIdRegional = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClickLogin = () => {
    const currentParams = location.search;
    navigate(`/regional_retail-onboarding_phone-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="screen-coporativo-card-id">
      <div className="corporativo-6">
        <div className="molecula-stepper-2">
          <div className="content-6">
            <div className="numb-4">
              <div className="text-wrapper-13">1</div>
            </div>

            <div className="line-3" />
          </div>

          <div className="div-4">
            <div className="div-4">
              <div className="numb-5">
                <div className="text-wrapper-14">2</div>
              </div>

              <div className="line-4" />
            </div>
          </div>

          <div className="div-4">
            <div className="div-4">
              <div className="numb-6">
                <div className="element-3">3</div>
              </div>

              <div className="line-5" />
            </div>
          </div>

          <div className="div-4">
            <div className="div-4">
              <div className="numb-6">
                <div className="element-3">4</div>
              </div>

              <div className="line-5" />
            </div>
          </div>

          <div className="div-4">
            <div className="div-4">
              <div className="numb-6">
                <div className="element-3">5</div>
              </div>

              <div className="line-5" />
            </div>
          </div>

          <div className="content-wrapper">
            <div className="content-7">
              <div className="numb-6">
                <div className="element-3">6</div>
              </div>
            </div>
          </div>
        </div>

        <div className="frame-12">
          <svg
            width={98}
            height={73}
            viewBox="0 0 98 73"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z"
              fill={colors.septimo}
            />
            <path
              d="M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z"
              fill={colors.secundario}
            />
            <path
              d="M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z"
              fill={colors.secundario}
            />
            <path
              d="M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z"
              fill={colors.secundario}
            />
            <path
              d="M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z"
              fill={colors.secundario}
            />
            <path
              d="M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z"
              fill={colors.secundario}
            />
            <path
              d="M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z"
              fill={colors.secundario}
            />
            <path
              d="M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z"
              fill={colors.secundario}
            />
            <path
              d="M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z"
              fill={colors.secundario}
            />
            <path
              d="M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z"
              fill={colors.secundario}
            />
            <path
              d="M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z"
              fill={colors.secundario}
            />
          </svg>
          <div className="frame-13">
            <div className="frame-14">
              <div className="frame-15">
                <p className="subtitle-11">Now, get your ID card</p>
              </div>

              <p className="subtitle-12">
                We will take a photo of the front &amp; back.
                <br />
                <br />
                Center your document in the frame and please make sure it
                doesn´t show any glare or shadows.
                <br />
                <br />
                Photos will be captured automatically.
              </p>
            </div>
          </div>

          <div className="input">
            <div className="e-mail">Country</div>

            <div className="frame-16">
              <div className="frame-17">
                <div className="text-wrapper-15">Select your country</div>

                <IconChevronDown1
                  className="icon-chevron-down"
                  color="#5C5C5C"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons-3">
          <div
            className="test-button-4 highlighted-button"
            onClick={handleButtonClickLogin}
          >
            <p className="text-wrapper-16">I´ve got my ID card!</p>
          </div>
        </div>

        <header className="header-3">
          <div className="overlap-9">
            <div className="frame-18">
              <div className="icon-arrow-back-1-wrapper">
                <IconArrowBack1 className="icon-arrow-back-1-instance" />
              </div>

              <div className="subtitle-13">Scan ID Card</div>
            </div>

            <div className="group-13">
              <div className="group-14">
                <div className="overlap-group-5">
                  <div className="rectangle-6" />
                  <div className="frame-19">
                    <svg
                      width={180}
                      height={170}
                      viewBox="0 0 200 190"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.05}
                      />
                      <path
                        d="M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.1}
                      />
                      <path
                        d="M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.1}
                      />
                      <path
                        d="M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.05}
                      />
                      <path
                        d="M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.1}
                      />
                      <path
                        d="M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.15}
                      />
                      <path
                        d="M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.2}
                      />
                      <path
                        d="M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.15}
                      />
                      <path
                        d="M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.1}
                      />
                      <path
                        d="M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.05}
                      />
                      <path
                        d="M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.05}
                      />
                      <path
                        d="M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.15}
                      />
                      <path
                        d="M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.2}
                      />
                      <path
                        d="M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.25}
                      />
                      <path
                        d="M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.2}
                      />
                      <path
                        d="M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.15}
                      />
                      <path
                        d="M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.1}
                      />
                      <path
                        d="M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.05}
                      />
                      <path
                        d="M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.2}
                      />
                      <path
                        d="M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.35}
                      />
                      <path
                        d="M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.45}
                      />
                      <path
                        d="M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.4}
                      />
                      <path
                        d="M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.3}
                      />
                      <path
                        d="M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.2}
                      />
                      <path
                        d="M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.15}
                      />
                      <path
                        d="M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.35}
                      />
                      <path
                        d="M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.65}
                      />
                      <path
                        d="M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.6}
                      />
                      <path
                        d="M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.55}
                      />
                      <path
                        d="M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.4}
                      />
                      <path
                        d="M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.25}
                      />
                      <path
                        d="M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.3}
                      />
                      <path
                        d="M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.55}
                      />
                      <path
                        d="M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.75}
                      />
                      <path
                        d="M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.6}
                      />
                      <path
                        d="M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.35}
                      />
                      <path
                        d="M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.4}
                      />
                      <path
                        d="M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.65}
                      />
                      <path
                        d="M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.6}
                      />
                      <path
                        d="M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.45}
                      />
                      <path
                        d="M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.5}
                      />
                      <path
                        d="M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z"
                        fill="#F2F3F7"
                        fillOpacity={0.7}
                      />
                      <path
                        d="M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z"
                        fill="#F2F3F7"
                        fillOpacity={0.8}
                      />
                      <path
                        d="M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                      <path
                        d="M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z"
                        fill="#F2F3F7"
                      />
                      <path
                        d="M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z"
                        fill="#F2F3F7"
                        fillOpacity={0.9}
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};
